'use client'

import { useEffect } from 'react'

export function IFrameRedirect() {
  useEffect(() => {
    if (window.self !== window.top) {
      // Preserve query params (e.g., returnTo)
      const search = window.location.search || ''
      window.location.href = `/embed-login${search}`
    }
  }, [])

  return null
}
